module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presentations"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.create(true)
      }
    }
  }, [_vm._v("Új szekció")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.create(false)
      }
    }
  }, [_vm._v("Új előadás")])], 1), _vm._v(" "), (_vm.rootPresentations.length == 0) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\n\t\t... Betöltés ...\n\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rootPresentations), function(presentation) {
    return _c('div', [_c('presentation-row', {
      attrs: {
        "presentation": presentation,
        "depth": 0
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23feba34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/PresentationsView.vue
// module id = 551
// module chunks = 2